<template>
  <main>
    <RepPopup :consultantId="consultantId" />
    <LayoutConnector name="home" :manifest="manifest" :form="AutoForm" />
  </main>
</template>

<route lang="json">
{
  "name": "home",
  "meta": { "fullWidth": true }
}
</route>

<script setup lang="ts">
import AutoForm from "@/components/PapaAutoForm.vue";
import RepPopup from "@/components/rep/RepPopup.vue";
import { useSSRStore } from "@/stores/ssr";
import { useUserStore } from "@/stores/user";
import { manifest } from "@/utils/layout_manifest";
import { useHead } from "@unhead/vue";
import LayoutConnector from "@virgodev/web-builder/components/LayoutConnector.vue";
import { useLayoutStore } from "@virgodev/web-builder/stores/layouts";
import { computed, onMounted, watch } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();

const user = useUserStore();
const ssr = useSSRStore();
const layouts = useLayoutStore();

const consultantId = computed(
  () => route.query.consultantId as string | undefined,
);

watch(layouts.list, () => {
  if (layouts.list.length > 0) {
    ssr.provides("layouts");
  }
});

useHead({
  title: "Affordable Fashion Jewelry",
  meta: [
    {
      name: "description",
      content:
        "Adorable, affordable fashion. Come see what Paparazzi Accessories has waiting for you!",
    },
  ],
  link: [
    {
      rel: "canonical",
      href: "https://paparazziaccessories.com",
    },
  ],
});

onMounted(async () => {
  // await layouts.sync();
  ssr.requires("products");
  ssr.requires("layouts");
});
</script>

<style scoped>
main :deep(.layout-viewer > *),
main :deep(.layout-builder .item) {
  margin-bottom: var(--1XL, 64px);
}
main :deep(.annoucement):last-child {
  margin-bottom: 0;
}

main.page {
  margin-top: 24px;
  margin-bottom: 0px;
}
@media (max-width: 800px) {
  main.page {
    margin: 28px 0;
  }
  main :deep(.layout-viewer > *),
  main :deep(.layout-builder .item),
  main :deep(.annoucement):last-child {
    margin-bottom: 28px;
  }
  .categories {
    padding: 10px 0;
  }
  main :deep(.category-list) {
    padding: 10px 0;
  }
  main :deep(a.category .label) {
    font-weight: 300;
  }
  main :deep(a.category .label:hover) {
    font-weight: 400;
  }
}
</style>
